import { render } from "./InvoiceNumberAssignment.vue?vue&type=template&id=09c5b644&ts=true"
import script from "./InvoiceNumberAssignment.vue?vue&type=script&lang=ts"
export * from "./InvoiceNumberAssignment.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__